/**
 * Cache Module Index
 *
 * Three caches, one per kind of thing worth not fetching twice:
 *  - requestCache: short-TTL GET responses (reference lists, dashboards)
 *  - mediaCache: object URLs for chat images and voice notes
 *  - messageCache: conversations and recent messages, in IndexedDB
 *
 * File downloads themselves are cached by the browser: the server tags every
 * file with an ETag and a year-long Cache-Control, since a file id names one
 * immutable blob.
 */

import { clearRequestCache } from './requestCache';
import { clearMediaCache } from './mediaCache';
import { clearMessageCache } from './messageCache';

export { CACHE_TTL, withRequestCache, invalidateRequestCache, clearRequestCache } from './requestCache';
export { getCachedMediaUrl, loadMediaUrl, clearMediaCache } from './mediaCache';
export {
  CACHED_MESSAGES_PER_CONVERSATION,
  readCachedConversations,
  writeCachedConversations,
  readCachedMessages,
  writeCachedMessages,
  clearMessageCache,
} from './messageCache';

/**
 * Drop everything that belongs to the signed-in user. Called whenever auth
 * data is deleted, so nothing survives into the next person's session.
 */
export const clearAllCaches = () => {
  clearRequestCache();
  clearMediaCache();
  // Async, and nothing waits on it: the message cache also checks ownership
  // on every read, so a slow clear cannot leak across accounts.
  clearMessageCache();
};
